<template>
  <div class="config-administradores">
    <div class="coming-soon">
      <i class="fas fa-user-shield"></i>
      <h2>Gestão de Administradores</h2>
      <p>Esta funcionalidade está sendo implementada.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfiguracoesAdministradores'
}
</script>

<style lang="scss" scoped>
.config-administradores {
  .coming-soon {
    background: white;
    border-radius: 15px;
    padding: 60px 30px;
    text-align: center;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);

    i {
      font-size: 64px;
      color: #667eea;
      margin-bottom: 20px;
    }

    h2 {
      margin: 0 0 15px 0;
      color: #2c3e50;
    }

    p {
      margin: 0;
      color: #6c757d;
    }
  }
}
</style>
